import {useState, useEffect} from 'react'
import {EyeInvisibleOutlined, EyeOutlined, LoadingOutlined} from '@ant-design/icons'
import {Button, Flex, message} from 'antd'
import {iiHOC} from '@/utils/auth';
import {showRequest} from "@/services";
import {
    getDecodeValue,
    operatePhoneLog,
    viewPhone,
  } from '@/services/member'
import {viewPhoneByClueId, viewPhoneBySource} from "@/services/callCenter";

export default function CheckThePhone(props) {
    const {initValue, auth, url, type, showValue, data = {}, clueId} = props;
    const [_fullPhone, _setFullPhone] = useState('');
    const [loading, setLoading] = useState<boolean>(false);

    const isSpecialChars = () => {
        // const regex = /[^0-9]/; // 匹配非数字字符
        // return regex.test(`${initValue}`);
        return `${initValue}`?.includes("*");
    }
    const onViewPhone = () => {
        if (loading) return;
        setLoading(true);
        if (!_fullPhone || _fullPhone == '') {
          const reqFn = url ? showRequest(url, type, data) : viewPhoneBySource(clueId, auth)
          reqFn.then((res: any) => {
              if (res) {
                _setFullPhone(res)
              }
              setLoading(false);
            }).finally(() => {
              setLoading(false);
            })

        } else {
            _setFullPhone('')
            setLoading(false);
        }
    }

    return iiHOC(
        initValue ? <Flex align="baseline">
            <Flex flex='center'>
                {!_fullPhone || _fullPhone == '' ? initValue : showValue?_fullPhone[showValue]:_fullPhone}
            </Flex>
          <div datareskey={auth ?? null}>
            {
                isSpecialChars() ? <div
                    style={{display: 'flex', alignItems: 'center', marginLeft: '6px', cursor: 'pointer'}}
                    onClick={onViewPhone}
                >
                    {loading ? <LoadingOutlined/> : (
                        _fullPhone ? <Button icon={<EyeOutlined/>} type="text" style={{ height: '22px', width: '22px' }}/>
                            : <Button icon={<EyeInvisibleOutlined/>} type="text" style={{ height: '22px', width: '22px' }}/>
                    )}
                </div> : null
            }
          </div>
        </Flex> : null
    )
}

export const CheckThePhoneFormItem = (props: any) => {
    const { fn, id, encodeValue, sysItem, param1, type, encodePhone, auth } = props
    const [_fullPhone, _setFullBackPhone] = useState('')
    const [loading, setLoading] = useState<boolean>(false)
    useEffect(() => {
      _setFullBackPhone('')
    }, [id])
    return iiHOC(
      <Flex>
        <Flex flex="center">{_fullPhone ? _fullPhone : encodePhone}</Flex>
        <div
          datareskey={auth ?? null}
          onClick={() => {
            if (loading) return
            setLoading(true)
            if (_fullPhone == '') {
              // sysItem: "WORKER_ORDER"   "ISSUE"
              // param1: 签约电话，联系电话
              if (type && type === 'clue') {
                viewPhone({ params: { id } })
                  .then((res: any) => {
                    _setFullBackPhone(res)
                    fn && fn(res)
                  })
                  .finally(() => {
                    setLoading(false)
                  })
              } else {
                if (!encodeValue || encodeValue === 'undefined') {
                  setLoading(false)
                  return
                }
                operatePhoneLog(id, 'SEE_PHONE_NUMBER', sysItem, param1)
                  .then((resp: any) => {
                    if (resp.data.message != '操作成功') {
                      setLoading(false)
                      return message.error('获取失败')
                    }
                    getDecodeValue(encodeValue)
                      .then((res: any) => {
                        if (res?.data) {
                          _setFullBackPhone(res?.data)
                          fn && fn(res?.data)
                        }
                      })
                      .finally(() => {
                        setLoading(false)
                      })
                  })
                  .catch(() => {
                    setLoading(false)
                  })
              }
            } else {
              _setFullBackPhone('')
              setLoading(false)
              fn && fn('')
            }
          }}
        >
          {loading ? (
            <LoadingOutlined />
          ) : _fullPhone ? (
            <Button icon={<EyeOutlined />} type="text" size="small" />
          ) : (
            <Button icon={<EyeInvisibleOutlined />} type="text" size="small" />
          )}
        </div>
      </Flex>
    )
}

export const CheckThePhoneInp = (props: any) => {
    const { fn, id, encodeValue, sysItem, param1, type, auth } = props
    const [_fullPhone, _setFullBackPhone] = useState('')
    const [loading, setLoading] = useState<boolean>(false)
    return iiHOC(
        <div
        onClick={() => {
            if (loading) return
            setLoading(true)
            if (_fullPhone == '') {
            // sysItem: "WORKER_ORDER"   "ISSUE"
            // param1: 签约电话，联系电话
            if (type && type === 'clue') {
                viewPhone({ params: { id } })
                .then((res: any) => {
                    _setFullBackPhone(res)
                    fn && fn(res)
                })
                .finally(() => {
                    setLoading(false)
                })
            } else {
                if (!encodeValue || encodeValue === 'undefined') {
                setLoading(false)
                return
                }
                operatePhoneLog(id, 'SEE_PHONE_NUMBER', sysItem, param1)
                .then((resp: any) => {
                    if (resp.data.message != '操作成功') {
                    setLoading(false)
                    return message.error('获取失败')
                    }
                    getDecodeValue(encodeValue)
                    .then((res: any) => {
                        if (res?.data) {
                        _setFullBackPhone(res?.data)
                        fn && fn(res?.data)
                        }
                    })
                    .finally(() => {
                        setLoading(false)
                    })
                })
                .catch(() => {
                    setLoading(false)
                })
            }
            } else {
            _setFullBackPhone('')
            setLoading(false)
            fn && fn('')
            }
        }}
        >
        {loading ? (
            <LoadingOutlined />
        ) : _fullPhone ? (
            <Button icon={<EyeOutlined />} type="text" size="small" datareskey={auth ?? null} />
        ) : (
            <Button
            icon={<EyeInvisibleOutlined />}
            type="text"
            size="small"
            datareskey={auth ?? null}
            />
        )}
        </div>
    )
}

export const CheckThePhoneInputForm = (props: any) => {
    const { fn, id, auth } = props
    const [_fullPhone, _setFullBackPhone] = useState('')
    const [loading, setLoading] = useState<boolean>(false)
    return iiHOC(
        <div
        onClick={() => {
            if (loading) return
            setLoading(true)
            if (_fullPhone == '') {
              viewPhoneBySource(id, auth)
                .then((res: any) => {
                    _setFullBackPhone(res)
                    fn && fn(res)
                })
                .finally(() => {
                    setLoading(false)
                })
            } else {
            _setFullBackPhone('')
            setLoading(false)
            fn && fn('')
            }
        }}
        >
        {loading ? (
            <LoadingOutlined />
        ) : _fullPhone ? (
            <Button icon={<EyeOutlined />} type="text" size="small" datareskey={auth ?? null} />
        ) : (
            <Button
            icon={<EyeInvisibleOutlined />}
            type="text"
            size="small"
            datareskey={auth ?? null}
            />
        )}
        </div>
    )
}

